module.exports = __webpack_public_path__ + "static/img/1-08.2fecee2.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-08.png
// module id = 209
// module chunks = 0